import { Injectable, inject } from '@angular/core';
import { Firestore, doc, getDoc } from '@angular/fire/firestore';
import { AuthService } from './auth.service';
import { availableAffiliations, knownAffiliations } from '../constants/constants';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserAffiliationService {
  private firestore = inject(Firestore);
  private authService = inject(AuthService);

  async getFilteredAffiliations() {
    const roles = await firstValueFrom(this.authService.userRoles$);
    const isSuperAdmin = roles.includes('super-admin');
    const isOrgAdmin = roles.includes('org-admin');

    // Super-admin: minden affiliáció
    if (isSuperAdmin) {
      return availableAffiliations;
    }

    const uid = this.authService.getCurrentUser()?.uid;
    if (!uid) {
      return availableAffiliations;
    }

    const userDoc = await getDoc(doc(this.firestore, 'Users', uid));
    if (!userDoc.exists()) {
      return availableAffiliations;
    }

    const userData = userDoc.data();

    // Org-admin: csak a hozzárendelt affiliációk
    if (isOrgAdmin) {
      const affiliationAdmin = userData['affiliationAdmin'] || [];
      if (affiliationAdmin.length === 0) {
        return availableAffiliations;
      }
      return knownAffiliations.filter(affiliation =>
        affiliationAdmin.includes(affiliation.value)
      );
    }

    // Normál felhasználó: csak a saját affiliációja + other opció
    const userAffiliation = userData['affiliation'];
    return availableAffiliations.filter(aff => 
      aff.value === userAffiliation || aff.value === 'other'
    );
  }
}
